import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Select, Row, Col, Table, Spin, message, notification, Button } from 'antd';

import axios from 'axios';
import BusCard from './BusCard';

const { Option } = Select;
const backend_url = process.env.REACT_APP_BACKEND_URL





function AllBus() {
  const location = useLocation();
  const filter = location.state?.filter;





  const [buses, setBuses] = useState([]);
  const [loading, setLoading] = useState(true);




  useEffect(() => {
    const fetchBuses = async () => {
      try {
        // const response = await axios.get(`http://localhost:8000/api/get-buses`);
        const response = await axios.get(`${backend_url}/api/get-buses`);
        setBuses(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
        message.error('Failed to fetch buses');
        setLoading(false);
      }
    };

    fetchBuses();
  }, []);



  const filteredBuses = buses.filter(bus =>
    (filter.fromCity.split(',')[0].trim() ? bus.fromStation === filter.fromCity.split(',')[0].trim() : true) &&
    (filter.toCity.split(',')[0].trim() ? bus.toStation === filter.toCity.split(',')[0].trim() : true)
  );






  function clickme() {
    {
      notification.error({
        message: 'Notification Title',
        description: 'This is the content of the notification. You can put anything here.',
        onClick: () => {
          console.log('Notification Clicked!');

        },
      });
    }
    console.log(typeof filter.date.toString())

  }


  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }






  return (
    <>
      {/* <div>
        <h1>All Buses </h1>
        {filter ? (
          <div>
            <p>Filter by toCity: {filter.toCity}</p>
            <p>Filter by fromCity: {filter.fromCity}</p>
            <p>Filter by date: {filter.date.toString()}</p>
            <Button type="primary" onClick={clickme}>
              Open Notification
            </Button>
          </div>

        ) : (
          <p>No filter applied</p>
        )}
      </div> */}
      <div className='bg-image h-[100vh]'>


        <div className="p-4 mx-auto max-w-2xl">
          <div className="flex  p-2 rounded-md shadow-md border">
              <div className="text-lg mx-auto text-gray-600 ">From : {filter.fromCity}</div>
              <div className="text-lg mx-auto text-gray-600 ">To : {filter.toCity}</div>
              <div className="text-lg mx-auto text-gray-600 ">On : {formatDate(filter.date)}</div>          
          </div>
        </div>

        <div>


          {
            !loading ?
              <div className='w-full '>
                {
                  filteredBuses.length > 0 ? (
                    filteredBuses.map(bus => (
                      <BusCard key={bus._id} bus={bus} date={filter.date} />
                    ))
                  ) : (
                    <p>No buses available for the selected route.</p>
                  )
                }
              </div>
              :
              <Spin />
          }



        </div>



      </div>



    </>
  )
}

export default AllBus

















